import { ref, computed } from "vue";
import { defineStore } from "pinia";

import { CHART_TYPE_OPTIONS, DEFAULT_CHART_TYPE } from "@/charts/registry/chartTypes";

export const useChartTypeStore = defineStore('chartType', () => {
    
    const chartType = ref(DEFAULT_CHART_TYPE)

    // One list, from the registry: adding a chart type is one entry there,
    // not a new object here and a new branch in each consumer.
    const availableChartTypes = CHART_TYPE_OPTIONS

    const getChartType = computed(() => chartType.value)

    function setChartType(selectedChartType){

        chartType.value = selectedChartType
    }

    function $reset(){
        chartType.value = DEFAULT_CHART_TYPE
    }

    return {
        chartType,
        getChartType,
        availableChartTypes,
        setChartType,
        $reset
    }
})